<div class="integration-wrapper">
	<h5 class="section-title">Integracja Gratyfikant</h5>

	@if (isLoading()) {
		<div class="loading-center">
			<mat-spinner diameter="32" />
		</div>
	} @else {
		<form [formGroup]="integrationForm" (ngSubmit)="save()">
			<div class="fields-row">
				<mat-form-field appearance="outline">
					<mat-label>ID Gratyfikant</mat-label>
					<input matInput formControlName="gratyfikant_id" maxlength="255" />
				</mat-form-field>
			</div>
			<button mat-flat-button color="primary" type="submit" [disabled]="isSaving()">
				@if (isSaving()) {
					<mat-spinner diameter="18" />
				}
				Zapisz
			</button>
		</form>
	}
</div>
